<!-- User Message -->
<ng-container *ngIf="message.sender === 'user'">
  <div class="c-chat-box__item c-chat-box__item--secondary">
    <div class="c-chat-box__msg">
      <div class="c-chat-box__item-body">
        <div class="c-chat-box__item-txt">
          <span class="c-chat-box__item-txt-block">{{ message.text }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Bot Message -->
<ng-container *ngIf="message.sender === 'bot'">
  <!-- Thinking Widget -->
  <div class="c-chat-box__item c-chat-box__think" *ngIf="message.notifications">
    <div class="c-chat-box__think-header tc-muted"
         [class.thinking-shine-continuous]="message.showNotifications"
         (click)="toggleNotifications(message)"
         style="cursor: pointer;">
      <span class="cap-strong">Thinking Process</span>
      <svg class="a-icon u-x0.75">
        <use [attr.xlink:href]="message.showNotifications ? '#pointer-up' : '#pointer-down'"></use>
      </svg>
    </div>
    <div class="c-chat-box__think-content" *ngIf="message.showNotifications">
      <p class="s" *ngIf="!message.notifications || message.notifications.length === 0">
        Processing your request...
      </p>
      <p class="s" *ngFor="let notification of message.notifications">{{ notification }}</p>
    </div>
  </div>

  <!-- Bot Content Items -->
  <ng-container *ngIf="message.content && message.content.length > 0">
    <div class="c-chat-box__item c-chat-box__item--primary">
      <div class="c-chat-box__msg">
        <div class="c-chat-box__item-header">
          <div class="c-chat-box__icon">
            <svg class="a-icon">
              <use xlink:href="#sparkles"></use>
            </svg>
          </div>
        </div>

        <div class="c-chat-box__item-body">
          <ng-container *ngFor="let contentItem of message.content">
            <ng-container *ngIf="contentItem.type === MESSAGE_TYPES.TEXT">
              <div class="c-chat-box__item-txt" [innerHTML]="formatChatText(contentItem.text)">
              </div>
            </ng-container>

            <!-- Hotel Table Slider -->
            <ng-container
              *ngIf="contentItem.type === MESSAGE_TYPES.TABLE && contentItem.contentType === TABLE_TYPES.HOTEL">
              <app-chat-hotel-slider [content]="contentItem.table.content"></app-chat-hotel-slider>
            </ng-container>

            <!-- Dynamic Table -->
            <ng-container
              *ngIf="contentItem.type === MESSAGE_TYPES.TABLE && contentItem.contentType === TABLE_TYPES.DYNAMIC && contentItem.table?.content">
              <app-chat-dynamic-table [content]="contentItem.table.content"></app-chat-dynamic-table>
            </ng-container>

            <!-- Component Button -->
            <ng-container *ngIf="contentItem.type === MESSAGE_TYPES.COMPONENT">
              <div class="c-chat-box__item-actions" style="flex-wrap: wrap;">
                <!-- Render suggestions from PromptSuggestionList -->
                <ng-container *ngIf="contentItem.component.component_type === COMPONENT_TYPES.PROMPT_SUGGESTION_LIST">
                  <!-- First group (hotel suggestions, empty heading) -->
                  <button
                    *ngFor="let suggestion of getValidSuggestions(contentItem.component.content.headingSuggestions[0]?.suggestions || [])"
                    class="a-btn a-btn--default t-tiny-pack c-chat-box__action-btn"
                    (click)="handleSuggestionClick(suggestion)">
                    {{ suggestion.message }}
                  </button>
                  <!-- Second group (Explore More Options) -->
                  <button
                    *ngFor="let suggestion of getValidSuggestions(contentItem.component.content.headingSuggestions[1]?.suggestions || [])"
                    class="a-btn a-btn--default t-tiny-pack c-chat-box__action-btn"
                    (click)="handleSuggestionClick(suggestion)">
                    {{ suggestion.message }}
                  </button>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div> <!-- end item-body -->
      </div>   <!-- end msg -->
    </div>     <!-- end item -->
  </ng-container>
</ng-container>
